export default "__VITE_ASSET__VbzY8Vcf__"